import isEqual from 'lodash/isEqual';
import axios from 'axios';

const titleTag = document.querySelector('title');
const { dataLayer, location } = window;

export default {
  current: {
    pathname: '',
    title: '',
  },

  set({
    pathname,
    title,
  } = {}) {
    const draft = {
      path: pathname || location.pathname,
      title: title
        ? `${title} | 國家識見`
        : '國家識見 - 小學人文科閱讀獎勵計劃平台',
    };

    if (isEqual(this.current, draft)) return;

    this.current = draft;

    if (titleTag) {
      titleTag.innerHTML = draft.title;
    }

    if (dataLayer) {
      dataLayer.push({
        event: 'pageview',
        pagePath: draft.pathname,
        pageTitle: draft.title,
      });
    }

    axios.get('/api/quiz/badges/appview');
  },
};
